var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileMail = function SvgProfileMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F0F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.744 14.633 7.528 4.894c.266.173.399.259.495.374a1 1 0 0 1 .189.348c.044.143.044.302.044.62v7.33c0 1.681 0 2.521-.327 3.163a3 3 0 0 1-1.311 1.31C31.72 33 30.88 33 29.2 33H18.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C14 30.72 14 29.88 14 28.2v-7.332c0-.317 0-.476.044-.62a1 1 0 0 1 .189-.347c.096-.115.229-.201.495-.374l7.528-4.894m3.488 0c-.631-.41-.947-.615-1.287-.695-.3-.07-.613-.07-.914 0-.34.08-.656.285-1.287.695m3.488 0 6.192 4.025c.688.447 1.032.671 1.151.954a1 1 0 0 1 0 .775c-.12.284-.463.507-1.15.954l-6.193 4.025c-.631.41-.947.616-1.287.696-.3.07-.613.07-.914 0-.34-.08-.656-.285-1.287-.696l-6.192-4.025c-.688-.447-1.032-.67-1.151-.954a1 1 0 0 1 0-.774c.12-.284.463-.508 1.15-.955l6.193-4.025M33.5 31l-6.643-6m-5.714 0L14.5 31",
    stroke: "#4A49BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgProfileMail;